import React, { Fragment, useState } from 'react'
import { graphql, PageRendererProps } from 'gatsby'

import { MdxPostNode } from '../types'
import BaseTemplate from '../components/shared/BaseTemplate'
import SocialMeta from '../components/shared/SocialMeta'
import HybridNav from '../components/shared/Nav/HybridNav'
import Footer from '../components/shared/Footer'
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer'
import Header from '../components/Blog/Post/Header'
import RecentPosts from '../components/Blog/Post/RecentPosts'
import { Container, Article, SocialFooter } from '../components/Blog/Post/styles'
import Tags from '../components/shared/Tags'
import Space from '../components/shared/Space'
import { PATHPREFIX } from '../constants'
import Newsletter from '../components/shared/Newsletter'
import MDXProviderWrapper from '../components/Blog/Post/MDXRenderer'

type SiteQuery = { siteMetadata: { siteUrl: string } }
type PostProps = { data: { mdx: MdxPostNode; site: SiteQuery } } & PageRendererProps

const Post = ({ data: { mdx, site }, location }: PostProps) => {
  console.log(location)
  const { date, abstract, series, indexInSeries, slug } = mdx.fields
  const {
    title,
    tags,
    metaTitle,
    metaDescription,
    heroImage,
    metaImage,
    heroImageAlt,
    video,
    authors,
    hackerNewsPostId,
  } = mdx.frontmatter
  const metaOrHero = metaImage || heroImage
  const url = `${site.siteMetadata.siteUrl}${location.pathname}`.replace(/\/+$/, '')
  const image = metaOrHero
  const [consoleUrl, setConsoleUrl] = useState('https://console.prisma.io/login?utm_source=website&utm_medium=header')

  React.useEffect(() => {
    //if (location) {
    const searchParams = location.search
    console.log(searchParams)
    setConsoleUrl(
      searchParams !== ''
        ? 'https://console.prisma.io/login' + searchParams
        : 'https://console.prisma.io/login?utm_source=website&utm_medium=header',
    )
    //}
  }, [])


  return (
    <BaseTemplate url={url} title={metaTitle || title}>
      {/* <PostDataProvider slug={slug}> */}
      <MDXProviderWrapper>
        <Fragment>
          <SocialMeta
            title={metaTitle || title}
            image={PATHPREFIX + image}
            description={metaDescription || abstract.text}
            type="article"
            video={video || null}
            url={url}
          />
          <HybridNav loc={consoleUrl} />

          <Article>
            <Header
              date={date}
              series={series}
              indexInSeries={indexInSeries}
              title={title}
              titleText={title}
              url={url}
              interaction={true}
              authors={authors}
              abstract={abstract && abstract.code}
              heroImage={heroImage}
              heroImageAlt={heroImageAlt}
            />
            <Container>
              <MDXRenderer>{mdx.body}</MDXRenderer>
              {tags && (
                <>
                  <Space height={90} />
                  <Tags tags={tags} />
                </>
              )}
              <SocialFooter>
                <h3>Don’t miss the next post!</h3>
                <p>Sign up for the Prisma Newsletter</p>
                <Newsletter placeholder="Subscribe for updates" />
              </SocialFooter>
            </Container>
          </Article>

          <RecentPosts slug={slug} />

          <Footer />
        </Fragment>
      </MDXProviderWrapper>
      {/* </PostDataProvider> */}
    </BaseTemplate>
  )
}

export default Post

export const pageQuery = graphql`
  query ($id: String!) {
    site {
      siteMetadata {
        siteUrl
      }
    }
    mdx(fields: { id: { eq: $id } }) {
      fields {
        slug
        date(formatString: "MMMM DD, YYYY")
        abstract {
          code
          text
        }
        indexInSeries
        series {
          ...PostSeriesListing
        }
      }
      frontmatter {
        title
        tags
        metaTitle
        metaDescription
        heroImage
        heroImageAlt
        metaImage
        hackerNewsPostId
        authors {
          ...AuthorMeta
        }
      }
      body
    }
  }
`
